module.exports = __webpack_public_path__ + "static/media/Tecnologia-Innovadora.095f8910.svg";